/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt per overtake`)
};

const es_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt por adelantamiento`)
};

const de_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 Pkt. pro Überholmanöver`)
};

const nl_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 pnt. per inhaalbeweging`)
};

const fr_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt par dépassement`)
};

const it_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt per sorpasso`)
};

const pt_br2_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt por ultrapassagem`)
};

const pt_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1pt por ultrapassagem`)
};

const ja_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーバーテイク1回につき+1pt`)
};

const zh_f1_table_legend_ov_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次超车 +1分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_table_legend_ov_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_table_legend_ov_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_table_legend_ov_desc", locale)
	if (locale === "en") return en_f1_table_legend_ov_desc(inputs)
	if (locale === "es") return es_f1_table_legend_ov_desc(inputs)
	if (locale === "de") return de_f1_table_legend_ov_desc(inputs)
	if (locale === "nl") return nl_f1_table_legend_ov_desc(inputs)
	if (locale === "fr") return fr_f1_table_legend_ov_desc(inputs)
	if (locale === "it") return it_f1_table_legend_ov_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_table_legend_ov_desc(inputs)
	if (locale === "pt") return pt_f1_table_legend_ov_desc(inputs)
	if (locale === "ja") return ja_f1_table_legend_ov_desc(inputs)
	return zh_f1_table_legend_ov_desc(inputs)
};